// Configuration de l'URL de l'API
// Détecte automatiquement si on est en production (HTTPS) ou développement
export const getApiUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Si on est sur HTTPS (production), utiliser une URL relative
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return '/api';
  }
  // Sinon, développement local
  return 'http://localhost:8000/api';
};

// Fonction pour obtenir l'URL de l'API (évaluée dynamiquement)
export const API_URL = () => getApiUrl();

// Export aussi une constante pour la compatibilité (mais elle sera évaluée au runtime)
export const getApiUrlSync = () => {
  // Toujours utiliser une URL relative en production
  if (typeof window !== 'undefined') {
    return '/api';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
};

